import { render, staticRenderFns } from "./PhysioList.vue?vue&type=template&id=7fa43306"
import script from "./PhysioList.vue?vue&type=script&lang=js"
export * from "./PhysioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports